import { customMedia } from '@space-lib/styles'
import styled from 'styled-components'

interface StyledBannerProps {
  isBannerClosed: boolean
}

export const Wrapper = styled.div<StyledBannerProps>`
  position: sticky;
  top: 0;
  height: ${({ isBannerClosed }) => (isBannerClosed ? '0px' : `var(--component-height-lg)`)};
  opacity: ${({ isBannerClosed }) => (isBannerClosed ? '0' : '1')};
  padding: ${({ isBannerClosed }) =>
    isBannerClosed ? `0px var(--spacer-3)` : `var(--spacer-2) var(--spacer-3)`};
  left: 0;
  z-index: ${({ isBannerClosed }) => (isBannerClosed ? '0' : '10')};
  background-color: var(--brand-secondary-darkest);
  align-items: center;
  transition: height var(--timing) var(--easing), opacity var(--timing) var(--easing),
    padding var(--timing) var(--easing);
`

export const WrapperMain = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const MainClickableArea = styled.div`
  display: flex;
  gap: 8px;
  height: auto;
  align-items: center;
  font-weight: var(--font-weight-bold);

  .banner-icon {
    display: none;
  }

  &:hover {
    cursor: pointer;
  }

  ${customMedia.greaterThan('sm')`
    .banner-icon {
      display: flex;
    }
  `}
`

export const LogoBanner = styled.img`
  max-height: 36px;
  object-fit: scale-down;
  object-position: center center;
`

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  min-width: 24px;
  padding: var(--spacer-1) 0px;
  background: transparent;
  border: none;

  &:hover {
    cursor: pointer;
  }
`
